import { Box, Typography } from "@mui/material"
import { shouldRenderPlaceholder } from "./pdf-task-comparison-helpers"
import { PdfTaskPlaceholder } from "./pdf-task-placeholder"
import { normaliseText } from "./pdf-formatters"

export function HeaderPanel({ task, status, side, showUnchangedNote }) {
    if (shouldRenderPlaceholder({ task, status, side, showUnchangedNote })) {
        return <PdfTaskPlaceholder status={status} side={side} />
    }

    if (!task) {
        return <PdfTaskPlaceholder status="missing" side={side} />
    }

    const normalisedPdfTitle = normaliseText(task.title)

    return (
        <Box sx={{ bgcolor: "#ebecef", borderRadius: "8px", px: "14px", py: "12px" }}>
            <Typography sx={{ fontWeight: 700, fontSize: "10px", color: "#1f2937" }}>{normalisedPdfTitle}</Typography>
        </Box>
    )
}
